import { useCallback, useEffect, useState } from "react";
import { api } from "../lib/api";

let scriptPromise = null;

function loadScript(sitekey) {
  if (window.grecaptcha) return Promise.resolve();
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector("script[data-recaptcha-v3]");
    if (existing) {
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", () => reject(new Error("recaptcha_load_failed")));
      return;
    }
    const sc = document.createElement("script");
    sc.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(sitekey)}`;
    sc.async = true;
    sc.defer = true;
    sc.dataset.recaptchaV3 = "true";
    sc.onload = () => resolve();
    sc.onerror = () => reject(new Error("recaptcha_load_failed"));
    document.head.appendChild(sc);
  });
  return scriptPromise;
}

export function useRecaptcha(action) {
  const [cfg, setCfg] = useState({ enabled: false, sitekey: "" });
  useEffect(() => {
    api.get("/public/integrations/recaptcha").then((r) => setCfg(r.data || { enabled: false, sitekey: "" })).catch(() => setCfg({ enabled: false, sitekey: "" }));
  }, []);
  useEffect(() => {
    if (cfg.enabled && cfg.sitekey) loadScript(cfg.sitekey).catch(() => {});
  }, [cfg.enabled, cfg.sitekey]);
  const getToken = useCallback(async () => {
    if (!cfg.enabled || !cfg.sitekey) return undefined;
    try {
      await loadScript(cfg.sitekey);
      if (!window.grecaptcha) return undefined;
      return await new Promise((resolve, reject) => {
        window.grecaptcha.ready(() => {
          window.grecaptcha.execute(cfg.sitekey, { action }).then(resolve).catch(reject);
        });
      });
    } catch { return undefined; }
  }, [action, cfg.enabled, cfg.sitekey]);
  return { getToken, enabled: cfg.enabled };
}
